import { ContextData } from "../provider/invoiceProvider";
import { ThemeContextData } from "../firstModule/page";

export const initiateInvoiceTransaction = async (
  invoiceData: ContextData["invoiceData"],
): Promise<ThemeContextData["invoiceLink"] | null> => {
  if (!invoiceData) return null;

  try {
    const response = await fetch(
      `${process.env.REACT_APP_BACKEND_BASE_URL}/Merchent/merchantInitiateInvoiceTransaction`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          mobileNo: invoiceData.vendor_number,
          amount: invoiceData.payable_amount,
          invoiceId: invoiceData.invoiceId,
        }),
      },
    );

    if (!response.ok) {
      throw new Error("API request failed");
    }

    const result = await response.json();

    const finalData: ThemeContextData["invoiceLink"] = {
      link: result?.data?.link,
      order_id: result?.data?.order_id,
    };

    return finalData;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
};
